module.exports = __webpack_public_path__ + "static/media/depositoFijo.c24c6e64.svg";